import * as React from 'react';

import IllustrativeTooltip from 'bundles/enterprise-legacy-learner-home/components/IllustrativeTooltip/IllustrativeTooltip';
import ProgressBar from 'bundles/skills-common/private/progress-tracker/ProgressBar';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

const SvgTargetProficiencyScore: React.FC<{ hideTarget?: boolean }> = ({ hideTarget }) => {
  return (
    <div style={{ width: 320 }}>
      <IllustrativeTooltip width={220} anchorLeft={21}>
        <div style={{ fontSize: 24 }}>
          <strong style={{ color: 'var(--cds-color-neutral-primary)' }}>{(180).toLocaleString()}</strong>
        </div>
        <div style={{ color: 'var(--cds-color-neutral-primary)', fontSize: 12, fontWeight: 'bold', marginBottom: 8 }}>
          {_t('Target score for this skill')}
        </div>
        <div style={{ color: 'var(--cds-color-grey-500)', fontSize: 11 }}>
          {_t('Proficiency targets are indicators of skill proficiency determined by your organization')}
        </div>
      </IllustrativeTooltip>
      <ProgressBar segments={[50, 150, 350]} target={hideTarget ? undefined : 180} />
    </div>
  );
};

export default SvgTargetProficiencyScore;
